<template>
    <div class="stripe-source-card" :class="{loading: loading}">
        <fieldset>
            <form @submit.prevent="saveCard" accept-charset="UTF-8" novalidate="novalidate">
                <legend>Add Card</legend>

                <div class="form-group has-feedback"
                     :class="{'has-error': errors.has('card-token')}">
                    <div class="card-element form-control"></div>

                    <span v-show="errors.has('card-token')" class="help-block">
                        {{ errors.first('card-token') }}
                    </span>
                </div>

                <hr>

                <div class="form-group">
                    <button type="submit" class="btn btn-success" :disabled="loading">
                        Save Card
                    </button>
                </div>
            </form>
        </fieldset>
    </div>
</template>

<script>
    /**
     * Note: Cannot be nested within a form element with a non-https action
     */
    export default {
        props: {
            afterSave: {
                default: () => {
                    return function(){
                    };
                }
            },

            modalId: {
                default: function(){
                    return Math.random().toString();
                },
                type: String
            },
        },

        created(){
            this.init();
        },

        data(){
            return {
                loading: false,

                style: {
                    base: {
                        color: '#282828',
                        fontFamily: '"Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
                        fontSmoothing: 'antialiased',
                        fontSize: '16px',
                        '::placeholder': {
                            color: '#282828'
                        },
                        lineHeight: '26px',
                        padding: '8px'
                    },

                    invalid: {
                        color: '#C70039',
                        iconColor: '#900C3F'
                    }
                },

                card: null,
                elements: null,
                stripe: null,
            };
        },

        computed: {
            form(){
                var form = document.createElement( 'form' );
                form.setAttribute( 'method', 'POST' );
                form.setAttribute( 'action', '/stripeCustomer/sources' );

                var hiddenField = document.createElement( 'input' );
                hiddenField.setAttribute( 'type', 'hidden' );
                hiddenField.setAttribute( 'name', '_method' );
                hiddenField.setAttribute( 'value', 'POST' );

                var token = $( 'meta[name="csrf-token"]' ).attr( 'content' );
                var tokenField = document.createElement( 'input' );
                tokenField.setAttribute( 'type', 'hidden' );
                tokenField.setAttribute( 'name', '_token' );
                tokenField.setAttribute( 'value', token );

                form.appendChild( tokenField );
                form.appendChild( hiddenField );

                return form;
            },
        },

        watch: {
            card(){
                if( this.card !== null ){
                    var self = this;

                    this.card.addEventListener( 'change', function( event ){
                        if( event.error ){
                            self.errors.add( {
                                field: 'token',
                                msg: event.error.message
                            } );
                        }
                        else {
                            self.errors.clear();
                        }
                    } );
                }
            }
        },

        methods: {
            init(){
                var promise = Promise.resolve();

                this.loading = true;

                promise
                    .then( () => {
                        return this.loadStripe();
                    } )
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( this.$root.handleErrors );
            },

            loadStripe(){
                this.stripe = Stripe( process.env.MIX_STRIPE_PUBLIC_KEY );
                this.elements = this.stripe.elements();
                this.card = this.elements.create( 'card', { style: this.style } );
                this.card.mount( this.$el.getElementsByClassName( 'card-element' )[ 0 ] );
            },

            saveCard(){
                this.loading = true;

                return this.stripe.createToken( this.card )
                    .then( ( result ) => {
                        if( result.error ){
                            this.errors.add( {
                                field: 'card-token',
                                msg: result.error.message
                            } );
                        }
                        else {
                            return this.postSource( result.token );
                        }
                    } )
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( this.$root.handleErrors );
            },

            postSource( token ){
                var form = this.form;
                var sourceTokenField = document.createElement( 'input' );
                sourceTokenField.setAttribute( 'name', 'Source[token]' );
                sourceTokenField.setAttribute( 'value', token.id );
                form.appendChild( sourceTokenField );

                document.body.appendChild( form );
                form.submit();
            },

            resetData(){
                Object.assign( this.$data, this.$options.data() );
            },
        }
    }
</script>
